import * as Yup from 'yup';

const isCheckCreate = (type) => {
  if (type === 'create') {
    return true;
  }
};
const isCheckEdit = (type) => {
  if (type === 'edit') {
    return true;
  }
};

const validationSchema = ({ type, t }) => Yup.object().shape({
  title: Yup.string().when([], {
    is: () => true,
    then: () => Yup.string()
      .typeError('Title must be string')
      .required(t('general.message.field_required')),
  }),
  company_cust_jobdesc_id: Yup.string().when([], {
    is: () => isCheckEdit(type),
    then: () => Yup.string()
      .required(t('general.message.field_required')),
  }),
});

export default validationSchema;
